import {
    Backdrop,
    CircularProgress,
    Container,
    Dialog,
    DialogContent,
    Divider,
    Grid,
    MuiThemeProvider, Typography
} from "@material-ui/core";
import { ArrowBack, Save as SaveIcon } from "@material-ui/icons";
import MUIDataTable from "mui-datatables";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import ButtonUI from "../../components/ui/ButtonUI";
import LoadingUI from "../../components/ui/LoadingUI";
import PageTitle from "../../components/ui/PageTitleUI";
import { useAuth } from "../../hooks/auth";
import MvmStatus from "../../interfaces/MvmStatus";
import MvmApi from "../../services/MvmApi";
import getDefaultGridOptions, {
    defaultGridTheme
} from "../../utils/componentUtils";
import utilsDate from "../../utils/Date";
import MvmSummary from "./components/MvmSummary";
import { DialogTitle, useStyles } from "./Style";
import { Alert, AlertTitle } from "@mui/material";

interface IFormInput {
    mvmNumber: any;
}

const ExportRacks: React.FC = () => {
    const history = useHistory();
    const classes = useStyles();
    const { t } = useTranslation("Mvm");
    const { t: _t } = useTranslation("General");
    const { t: it } = useTranslation("MvmInvoice");
    const [mvm, setMvm] = useState<any>(null);
    const { enqueueSnackbar } = useSnackbar();
    const [openedPainel, setOpenedPainel] = useState(false);
    const [mvmId, setMvmId] = useState<number>(0);
    const [hasExportError, setHasExportError] = useState<boolean>(false);
    const [mdrMessage, setMdrMessage] = useState<boolean>(false);
    const [canSubmit, setCanSubmit] = useState<boolean>(false);
    const [circularLoading, setCircularLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [invoicesItems, setInvoiceItems] = useState([]);
    const [mvmNumber, setMvmNumber] = useState<string>("");
    const [queryMvmId, setQueryMvmId] = useState<any>(null);
    const { user } = useAuth();
    const { control, handleSubmit, setValue, getValues } = useForm<IFormInput>({
        defaultValues: { mvmNumber: {} },
    });

    useEffect(() => {
        var mvmId = Number(
            window.location.pathname.replace("/ExportRacks/", "")
        );

        if (isNaN(mvmId)) {
            setMvmId(0);
            setMvm(null);
            return;
        } else {
            setQueryMvmId(mvmId);
        }
    }, [window.location.pathname]);

    const onSummaryChange = (data: any) => {
        if (!data) {
            setMvmId(0);
            setMvmNumber("");
            setMvm(null);
            return;
        }

        setMvmNumber(data.mvmNumber);
        setMvm(data);

        setMvmId(data.id);

        //Exibir na grid os items de NFs do tipo Embalagem
        let invoiceItems: any = [];
        data.invoices.map((invoice: any) => {
            if (invoice.invoiceType == "E") {
                invoiceItems.push({
                    id: invoice.id,
                    invoiceKey: invoice.invoiceKey,
                    invoiceNumber: invoice.invoiceNumber,
                    invoiceDate: invoice.invoiceDate,
                    rackTypeCode: invoice.rackTypeCode,
                    itemQuantity: invoice.items.length,
                });
            }
        });

        setCanSubmit(invoiceItems.length > 0);

        setInvoiceItems(invoiceItems);
        setCircularLoading(false)
    };

    const onSubmit = (data: any) => {
        setLoading(true)
        if (mvmId == 0) {
            enqueueSnackbar(t("returnSearchMvmNotFoundMessage"), {
                variant: "warning",
            });

            history.replace(`/RegisterVehicleArrival/${mvmId}`);
            return;
        }

        MvmApi.exportRacks(mvmId).then((response) => {
            setHasExportError(response.data?.errors ?? false);
            setMdrMessage(response.data?.aditionalSucessMessage);

            enqueueSnackbar(_t("returnSubmitEditFormSuccess"), {
                variant: "success",
            });
            setLoading(false)
            setOpenedPainel(true)
        });

        setCircularLoading(false);
    };

    function handleExportRedirect () {
        var MvmId = Number(
            window.location.pathname.replace("/ExportRacks/", "")
        );
        history.replace(`/RegisterVehicleArrival/${mvmId}`)
        setOpenedPainel(false)
    }

    const columns = [
        {
            name: "id",
            options: {
                display: false,
            },
        },
        {
            name: "invoiceKey",
            label: String(it("invoiceKey")),
            options: {
                sort: false,
                setCellHeaderProps: () => ({ align: "center" }),
                setCellProps: () => ({ align: "center" }),
            },
        },
        {
            name: "invoiceNumber",
            label: String(it("invoiceNumber")),
            options: {
                sort: false,
                setCellHeaderProps: () => ({ align: "center" }),
                setCellProps: () => ({ align: "center" }),
            },
        },
        {
            name: "invoiceDate",
            label: String(it("invoiceDate")),
            options: {
                sort: false,
                setCellHeaderProps: () => ({ align: "center" }),
                setCellProps: () => ({ align: "center" }),
                customBodyRender: (value: any) => {
                    return utilsDate.DateShort(value);
                },
            },
        },
        {
            name: "rackTypeCode",
            label: String(it("rackTypeCode")),
            options: {
                sort: false,
                setCellHeaderProps: () => ({ align: "center" }),
                setCellProps: () => ({ align: "center" }),
            },
        },
        {
            name: "itemQuantity",
            label: String(it("itemQuantity")),
            options: {
                sort: false,
                setCellHeaderProps: () => ({ align: "center" }),
                setCellProps: () => ({ align: "center" }),
            },
        },
    ];

    return (
        <Container maxWidth={false} component="main">
            <Dialog
                open={openedPainel}
                aria-labelledby="form-dialog-title"
                onBackdropClick={() => handleExportRedirect()}
                >

                <DialogTitle classes={{ root: classes.dialogTitle }}
                    id="draggable-dialog-title"
                    onClose={() => handleExportRedirect()}>
                    {`Receber Vasilhames`}
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <span className={classes.rootForm} style={{ margin: '0px' }}>
                                { !hasExportError ? 'Os vasilhames foram recebidos com sucesso!' : 'Houve um erro ao receber os vasilhames!' }
                            </span>
                        </Grid>
                        
                        {mdrMessage && (
                        <Grid item xs={12}>
                            <Alert severity={hasExportError ? "warning" : "success"} style={{fontSize: 22}}>
                            <AlertTitle>{_t("information")}</AlertTitle>
                                <small style={{fontSize: '0.9rem'}}>{mdrMessage}</small>
                            </Alert>
                        </Grid>)}

                        <Grid item xs={12} style={{textAlign: 'center'}}>
                            <ButtonUI
                                color="secondary"
                                onClick={() => handleExportRedirect()}
                                style={{ maxWidth: '100px', maxHeight: '38px', minWidth: '40px', minHeight: '38px' }}
                            >
                            {_t("confirm")}
                            </ButtonUI>
                        </Grid>
                    </Grid>
                </DialogContent>

            </Dialog>
            
            <PageTitle title={t("titleExportRacks")} />
                            
                    <div className={classes.rootContent}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Divider style={{ marginTop: "10px" }} />
                            {
                                loading ? <LoadingUI /> :
                                <>
                                    <MvmSummary
                                        queryMvmId={queryMvmId}
                                        control={control}
                                        name={"summary"}
                                        onChange={onSummaryChange}
                                        setValue={setValue}
                                        mvmStatus={[
                                            MvmStatus.FLAG_STATUS_PENDING_ENTRANCE,
                                            MvmStatus.FLAG_STATUS_PENDING_UNLOAD,
                                            MvmStatus.FLAG_STATUS_PENDING_FINISH_UNLOAD,
                                            MvmStatus.FLAG_STATUS_PENDING_LOAD,
                                            MvmStatus.FLAG_STATUS_PENDING_EXIT,
                                            MvmStatus.FLAG_STATUS_PENDING_BILLING,
                                            MvmStatus.FLAG_STATUS_PENDING_INVOICING,
                                        ]} //PEM,PID,PFD,PIC,PSM,PEC,PFA
                                        includeProperties={["Invoices"]}
                                    />

                                    {
                                        mvmId === 0 ? (
                                        <></>
                                        ) : 
                                            <>
                                                <Grid
                                                    style={{
                                                        marginTop: 20,
                                                        width: "98%",
                                                        marginLeft: 10,
                                                        marginBottom: 10,
                                                    }}
                                                >
                                                    <Typography
                                                        className={classes.root}
                                                        style={{ marginLeft: 0 }}
                                                    >
                                                        {t("invoices")}
                                                    </Typography>
                                                    

                                                            <MuiThemeProvider theme={defaultGridTheme}>
                                                                <MUIDataTable
                                                                    title=""
                                                                    data={invoicesItems}
                                                                    columns={columns}
                                                                    options={{
                                                                        ...getDefaultGridOptions(_t),
                                                                        serverSide: false,
                                                                        pagination: false,
                                                                        sort: false,
                                                                        selectToolbarPlacement: "none",
                                                                        filter: false,
                                                                        search: false,
                                                                        download: false,
                                                                        print: false,
                                                                        viewColumns: false,
                                                                        selectableRows: "none",
                                                                    }}
                                                                />
                                                            </MuiThemeProvider>
                                                    
                                                </Grid>
                                                <Backdrop
                                                    style={{ zIndex: 9999 }}
                                                    open={circularLoading}
                                                >
                                                    <CircularProgress color="inherit" />
                                                </Backdrop>
                                                <Grid container spacing={1}>
                                                    <ButtonUI
                                                        style={{ marginTop: 15 }}
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={() => window.location.reload()}
                                                        startIcon={<ArrowBack />}
                                                    >
                                                        {_t("back")}
                                                    </ButtonUI>
                                                    <ButtonUI
                                                        style={{ marginTop: 15 }}
                                                        variant="outlined"
                                                        color="primary"
                                                        type="submit"
                                                        disabled={!canSubmit}
                                                        startIcon={<SaveIcon />}
                                                    >
                                                        {it("confirmRackReceive")}
                                                    </ButtonUI>
                                                </Grid>
                                            </>
                                    }
                                </>
                            }
                        </form>
                </div>
        </Container>
    );
};
export default ExportRacks;
